module.exports = __webpack_public_path__ + "img/mob-panel-dowload.17c447e8.svg";